import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRotate360Right: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRotate360Right"><Path d="M10.5 13.5L13.5 16.5L10.5 19.5" stroke="currentColor"/><Path d="M17.25 15.7642C20.3885 14.8132 22.5 13.0358 22.5 11C22.5 7.96243 17.799 5.5 12 5.5C6.20101 5.5 1.5 7.96243 1.5 11C1.5 14.0376 6.20101 16.5 12 16.5H13.0244" stroke="currentColor"/></CentralIconBase>;
});

export default IconRotate360Right;
